import { render, staticRenderFns } from "./PwdLogin.vue?vue&type=template&id=95fd0a14&scoped=true&"
import script from "./PwdLogin.vue?vue&type=script&lang=js&"
export * from "./PwdLogin.vue?vue&type=script&lang=js&"
import style0 from "./PwdLogin.vue?vue&type=style&index=0&id=95fd0a14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fd0a14",
  null
  
)

export default component.exports